// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AbsenceExportController from "./absence_export_controller"
application.register("absence-export", AbsenceExportController)

import AccountDeleteModalController from "./account_delete_modal_controller"
application.register("account-delete-modal", AccountDeleteModalController)

import AccountRoleChangeModalController from "./account_role_change_modal_controller"
application.register("account-role-change-modal", AccountRoleChangeModalController)

import ActiveTabScrollController from "./active_tab_scroll_controller"
application.register("active-tab-scroll", ActiveTabScrollController)

import AssetCostAmountsController from "./asset_cost_amounts_controller"
application.register("asset-cost-amounts", AssetCostAmountsController)

import AssetCostReceiptExtractionController from "./asset_cost_receipt_extraction_controller"
application.register("asset-cost-receipt-extraction", AssetCostReceiptExtractionController)

import AssetCostPeriodController from "./asset_cost_period_controller"
application.register("asset-cost-period", AssetCostPeriodController)

import AssetCostDamageController from "./asset_cost_damage_controller"
application.register("asset-cost-damage", AssetCostDamageController)

import BulkAccountCreationController from "./bulk_account_creation_controller"
application.register("bulk-account-creation", BulkAccountCreationController)

import ComponentPickerController from "./component_picker_controller"
application.register("component-picker", ComponentPickerController)

import DamageFormController from "./damage_form_controller"
application.register("damage-form", DamageFormController)

import ActivityHeartbeatController from "./activity_heartbeat_controller"
application.register("activity-heartbeat", ActivityHeartbeatController)

import ActivityHoursController from "./activity_hours_controller"
application.register("activity-hours", ActivityHoursController)

import AddAllDevicesController from "./add_all_devices_controller"
application.register("add-all-devices", AddAllDevicesController)

import AiMappingCountdownController from "./ai_mapping_countdown_controller"
application.register("ai-mapping-countdown", AiMappingCountdownController)

import AiTemplateImportController from "./ai_template_import_controller"
application.register("ai-template-import", AiTemplateImportController)

import AllDayToggleController from "./all_day_toggle_controller"
application.register("all-day-toggle", AllDayToggleController)

import AllowanceCompatibilityController from "./allowance_compatibility_controller"
application.register("allowance-compatibility", AllowanceCompatibilityController)

import AllowanceEditorTabsController from "./allowance_editor_tabs_controller"
application.register("allowance-editor-tabs", AllowanceEditorTabsController)

import AllowanceInputController from "./allowance_input_controller"
application.register("allowance-input", AllowanceInputController)

import AllowanceListController from "./allowance_list_controller"
application.register("allowance-list", AllowanceListController)
import AllowanceSectionController from "./allowance_section_controller"
application.register("allowance-section", AllowanceSectionController)

import AllowanceRecalculateController from "./allowance_recalculate_controller"
application.register("allowance-recalculate", AllowanceRecalculateController)

import AllowanceSummaryController from "./allowance_summary_controller"
application.register("allowance-summary", AllowanceSummaryController)

import AmountController from "./amount_controller"
application.register("amount", AmountController)

import ApprovalFormController from "./approval_form_controller"
application.register("approval-form", ApprovalFormController)

import AttachmentPreviewController from "./attachment_preview_controller"
application.register("attachment-preview", AttachmentPreviewController)

import AttachmentsdraggableController from "./attachmentsdraggable_controller"
application.register("attachmentsdraggable", AttachmentsdraggableController)

import AudioRecorderController from "./audio_recorder_controller"
application.register("audio-recorder", AudioRecorderController)

import AutoDailyEntriesFormController from "./auto_daily_entries_form_controller"
application.register("auto-daily-entries-form", AutoDailyEntriesFormController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutocompleteChangeController from "./autocomplete_change_controller"
application.register("autocomplete-change", AutocompleteChangeController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BeamChatComposerController from "./beam_chat_composer_controller"
application.register("beam-chat-composer", BeamChatComposerController)

import BeamChatScrollController from "./beam_chat_scroll_controller"
application.register("beam-chat-scroll", BeamChatScrollController)

import BeamFleetMapController from "./beam_fleet_map_controller"
application.register("beam-fleet-map", BeamFleetMapController)

import BeamMissionPlanningController from "./beam_mission_planning_controller"
application.register("beam-mission-planning", BeamMissionPlanningController)

import BeamRobotDashboardController from "./beam_robot_dashboard_controller"
application.register("beam-robot-dashboard", BeamRobotDashboardController)

import BeamTeleopController from "./beam_teleop_controller"
application.register("beam-teleop", BeamTeleopController)

import BeamLiveViewController from "./beam_live_view_controller"
application.register("beam-live-view", BeamLiveViewController)

import BeamTeleopLayoutController from "./beam_teleop_layout_controller"
application.register("beam-teleop-layout", BeamTeleopLayoutController)

import BeamTeleopStageController from "./beam_teleop_stage_controller"
application.register("beam-teleop-stage", BeamTeleopStageController)

import BewirtungFormController from "./bewirtung_form_controller"
application.register("bewirtung-form", BewirtungFormController)

import BlockEntrySortController from "./block_entry_sort_controller"
application.register("block-entry-sort", BlockEntrySortController)

import BillingCostTypeController from "./billing_cost_type_controller"
application.register("billing-cost-type", BillingCostTypeController)

import BillingDocumentPreviewController from "./billing_document_preview_controller"
application.register("billing-document-preview", BillingDocumentPreviewController)

import BillingHourlyWorkController from "./billing_hourly_work_controller"
application.register("billing-hourly-work", BillingHourlyWorkController)

import BillingLayoutController from "./billing_layout_controller"
application.register("billing-layout", BillingLayoutController)

import BillingLineItemTypeController from "./billing_line_item_type_controller"
application.register("billing-line-item-type", BillingLineItemTypeController)

import BillingModalController from "./billing_modal_controller"
application.register("billing-modal", BillingModalController)

import BillingSendDialogController from "./billing_send_dialog_controller"
application.register("billing-send-dialog", BillingSendDialogController)

import BillingNavController from "./billing_nav_controller"
application.register("billing-nav", BillingNavController)

import BillingOfferBulkController from "./billing_offer_bulk_controller"
application.register("billing-offer-bulk", BillingOfferBulkController)

import BillingOfferRowEditController from "./billing_offer_row_edit_controller"
application.register("billing-offer-row-edit", BillingOfferRowEditController)

import BillingOfferTreeController from "./billing_offer_tree_controller"
application.register("billing-offer-tree", BillingOfferTreeController)

import BillingPartialInvoiceController from "./billing_partial_invoice_controller"
application.register("billing-partial-invoice", BillingPartialInvoiceController)

import BillingRecipientOverrideController from "./billing_recipient_override_controller"
application.register("billing-recipient-override", BillingRecipientOverrideController)

import BillingRentalPricingController from "./billing_rental_pricing_controller"
application.register("billing-rental-pricing", BillingRentalPricingController)

import BillingTerminationInvoiceController from "./billing_termination_invoice_controller"
application.register("billing-termination-invoice", BillingTerminationInvoiceController)

import BoardCalendarController from "./board_calendar_controller"
application.register("board-calendar", BoardCalendarController)

import BoardColumnsController from "./board_columns_controller"
application.register("board-columns", BoardColumnsController)

import BoardFilterController from "./board_filter_controller"
application.register("board-filter", BoardFilterController)

import BoardSearchController from "./board_search_controller"
application.register("board-search", BoardSearchController)

import BoqBulkController from "./boq_bulk_controller"
application.register("boq-bulk", BoqBulkController)

import SupplierQuoteController from "./supplier_quote_controller"
application.register("supplier-quote", SupplierQuoteController)

import BoqCatalogPickerController from "./boq_catalog_picker_controller"
application.register("boq-catalog-picker", BoqCatalogPickerController)

import BoqImportPricingController from "./boq_import_pricing_controller"
application.register("boq-import-pricing", BoqImportPricingController)

import BoqImportUploadController from "./boq_import_upload_controller"
application.register("boq-import-upload", BoqImportUploadController)

import BoqMappingController from "./boq_mapping_controller"
application.register("boq-mapping", BoqMappingController)

import BoqPositionAllocationsController from "./boq_position_allocations_controller"
application.register("boq-position-allocations", BoqPositionAllocationsController)

import BoqPreviewTreeController from "./boq_preview_tree_controller"
application.register("boq-preview-tree", BoqPreviewTreeController)

import BoqRowEditController from "./boq_row_edit_controller"
application.register("boq-row-edit", BoqRowEditController)

import BoqTreeController from "./boq_tree_controller"
application.register("boq-tree", BoqTreeController)

import BreakPeriodsTotalController from "./break_periods_total_controller"
application.register("break-periods-total", BreakPeriodsTotalController)

import BreakRuleController from "./break_rule_controller"
application.register("break-rule", BreakRuleController)

import BreakTimeMinutesController from "./break_time_minutes_controller"
application.register("break-time-minutes", BreakTimeMinutesController)

import BreakTimeStepperController from "./break_time_stepper_controller"
application.register("break-time-stepper", BreakTimeStepperController)

import BrzLayoutController from "./brz_layout_controller"
application.register("brz-layout", BrzLayoutController)

import BulkFieldController from "./bulk_field_controller"
application.register("bulk-field", BulkFieldController)

import BulkWorkingHoursController from "./bulk_working_hours_controller"
application.register("bulk-working-hours", BulkWorkingHoursController)

import CalendarAppointmentOpenerController from "./calendar_appointment_opener_controller"
application.register("calendar-appointment-opener", CalendarAppointmentOpenerController)

import CalendarCurrentDateController from "./calendar_current_date_controller"
application.register("calendar-current-date", CalendarCurrentDateController)

import CalendarDigestSettingsController from "./calendar_digest_settings_controller"
application.register("calendar-digest-settings", CalendarDigestSettingsController)

import CalendarDialogController from "./calendar_dialog_controller"
application.register("calendar-dialog", CalendarDialogController)

import CalendarDragController from "./calendar_drag_controller"
application.register("calendar-drag", CalendarDragController)

import CalendarPopoverController from "./calendar_popover_controller"
application.register("calendar-popover", CalendarPopoverController)

import CalendarResizeController from "./calendar_resize_controller"
application.register("calendar-resize", CalendarResizeController)

import CalendarSlotController from "./calendar_slot_controller"
application.register("calendar-slot", CalendarSlotController)

import CalendarTimeGridController from "./calendar_time_grid_controller"
application.register("calendar-time-grid", CalendarTimeGridController)

import CanvasimageController from "./canvasimage_controller"
application.register("canvasimage", CanvasimageController)

import CanvassketchController from "./canvassketch_controller"
application.register("canvassketch", CanvassketchController)

import CatalogDrawerController from "./catalog_drawer_controller"
application.register("catalog-drawer", CatalogDrawerController)

import CatalogEntryRowController from "./catalog_entry_row_controller"
application.register("catalog-entry-row", CatalogEntryRowController)

import CatalogSaveController from "./catalog_save_controller"
application.register("catalog-save", CatalogSaveController)

import CatalogSaveTriggerController from "./catalog_save_trigger_controller"
application.register("catalog-save-trigger", CatalogSaveTriggerController)

import CatalogTreeController from "./catalog_tree_controller"
application.register("catalog-tree", CatalogTreeController)

import CategoryController from "./category_controller"
application.register("category", CategoryController)

import CharCounterController from "./char_counter_controller"
application.register("char-counter", CharCounterController)

import CheckboxShowController from "./checkbox_show_controller"
application.register("checkbox-show", CheckboxShowController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import CollapsibleSectionController from "./collapsible_section_controller"
application.register("collapsible-section", CollapsibleSectionController)

import ColumnDrawerController from "./column_drawer_controller"
application.register("column-drawer", ColumnDrawerController)

import ColumnPickerController from "./column_picker_controller"
application.register("column-picker", ColumnPickerController)

import ColumnVisibilityController from "./column_visibility_controller"
application.register("column-visibility", ColumnVisibilityController)

import ColumnsController from "./columns_controller"
application.register("columns", ColumnsController)

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import ConfigurableCalendarHeatmapController from "./configurable_calendar_heatmap_controller"
application.register("configurable-calendar-heatmap", ConfigurableCalendarHeatmapController)

import ConfigurableExportController from "./configurable_export_controller"
application.register("configurable-export", ConfigurableExportController)

import ConfigurableTimesheetDialogController from "./configurable_timesheet_dialog_controller"
application.register("configurable-timesheet-dialog", ConfigurableTimesheetDialogController)

import ConfigurableTimesheetFilterController from "./configurable_timesheet_filter_controller"
application.register("configurable-timesheet-filter", ConfigurableTimesheetFilterController)

import ConfigurableTimesheetSidebarController from "./configurable_timesheet_sidebar_controller"
application.register("configurable-timesheet-sidebar", ConfigurableTimesheetSidebarController)

import ConfirmSubmitController from "./confirm_submit_controller"
application.register("confirm-submit", ConfirmSubmitController)

import ConflictTooltipController from "./conflict_tooltip_controller"
application.register("conflict-tooltip", ConflictTooltipController)

import CopyPreviousDayController from "./copy_previous_day_controller"
application.register("copy-previous-day", CopyPreviousDayController)

import CostingComponentPrefillController from "./costing_component_prefill_controller"
application.register("costing-component-prefill", CostingComponentPrefillController)

import CostingDrawerController from "./costing_drawer_controller"
application.register("costing-drawer", CostingDrawerController)

import CostingSectionsController from "./costing_sections_controller"
application.register("costing-sections", CostingSectionsController)

import CostingSummaryController from "./costing_summary_controller"
application.register("costing-summary", CostingSummaryController)

import CostingPreviewController from "./costing_preview_controller"
application.register("costing-preview", CostingPreviewController)

import CostingSurchargeMatrixController from "./costing_surcharge_matrix_controller"
application.register("costing-surcharge-matrix", CostingSurchargeMatrixController)

import CostingSurchargeOverrideController from "./costing_surcharge_override_controller"
application.register("costing-surcharge-override", CostingSurchargeOverrideController)

import CountersignatureFormController from "./countersignature_form_controller"
application.register("countersignature-form", CountersignatureFormController)

import CsvExportFieldsController from "./csv_export_fields_controller"
application.register("csv-export-fields", CsvExportFieldsController)

import CsvImportMappingController from "./csv_import_mapping_controller"
application.register("csv-import-mapping", CsvImportMappingController)

import CsvImportPollController from "./csv_import_poll_controller"
application.register("csv-import-poll", CsvImportPollController)

import CsvImportsController from "./csv_imports_controller"
application.register("csv-imports", CsvImportsController)

import CustomFieldsSubtabsController from "./custom_fields_subtabs_controller"
application.register("custom-fields-subtabs", CustomFieldsSubtabsController)

import CustomReportDeleteModalController from "./custom_report_delete_modal_controller"
application.register("custom-report-delete-modal", CustomReportDeleteModalController)

import CustomReportExportController from "./custom_report_export_controller"
application.register("custom-report-export", CustomReportExportController)

import CustomReportTypeDeleteModalController from "./custom_report_type_delete_modal_controller"
application.register("custom-report-type-delete-modal", CustomReportTypeDeleteModalController)

import CustomTableTotalsController from "./custom_table_totals_controller"
application.register("custom-table-totals", CustomTableTotalsController)

import CustomerGroupDropController from "./customer_group_drop_controller"
application.register("customer-group-drop", CustomerGroupDropController)

import CustomerOnRequestController from "./customer_on_request_controller"
application.register("customer-on-request", CustomerOnRequestController)

import CustomerSiteFilterController from "./customer_site_filter_controller"
application.register("customer-site-filter", CustomerSiteFilterController)

import CustomersSidebarController from "./customers_sidebar_controller"
application.register("customers-sidebar", CustomersSidebarController)

import DashboardAddPanelController from "./dashboard_add_panel_controller"
application.register("dashboard-add-panel", DashboardAddPanelController)

import DashboardCalendarController from "./dashboard_calendar_controller"
application.register("dashboard-calendar", DashboardCalendarController)

import DashboardChartController from "./dashboard_chart_controller"
application.register("dashboard-chart", DashboardChartController)

import DashboardEditModeController from "./dashboard_edit_mode_controller"
application.register("dashboard-edit-mode", DashboardEditModeController)

import DashboardGridController from "./dashboard_grid_controller"
application.register("dashboard-grid", DashboardGridController)

import DashboardHighlightController from "./dashboard_highlight_controller"
application.register("dashboard-highlight", DashboardHighlightController)

import DashboardSitesMapController from "./dashboard_sites_map_controller"
application.register("dashboard-sites-map", DashboardSitesMapController)

import DashboardStackedChartController from "./dashboard_stacked_chart_controller"
application.register("dashboard-stacked-chart", DashboardStackedChartController)

import DashboardTabsController from "./dashboard_tabs_controller"
application.register("dashboard-tabs", DashboardTabsController)

import DashboardWidgetRefreshController from "./dashboard_widget_refresh_controller"
application.register("dashboard-widget-refresh", DashboardWidgetRefreshController)

import DateFormatController from "./date_format_controller"
application.register("date-format", DateFormatController)

import DateNavigateController from "./date_navigate_controller"
application.register("date-navigate", DateNavigateController)

import DateRangePresetsController from "./date_range_presets_controller"
application.register("date-range-presets", DateRangePresetsController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DefaultSiteFormController from "./default_site_form_controller"
application.register("default-site-form", DefaultSiteFormController)

import DeputyChainController from "./deputy_chain_controller"
application.register("deputy-chain", DeputyChainController)

import DialogOpenerController from "./dialog_opener_controller"
application.register("dialog-opener", DialogOpenerController)

import DismissableCardController from "./dismissable_card_controller"
application.register("dismissable-card", DismissableCardController)

import ReleaseNotesController from "./release_notes_controller"
application.register("release-notes", ReleaseNotesController)

import SidebarEditorController from "./sidebar_editor_controller"
application.register("sidebar-editor", SidebarEditorController)

import SidebarSubpagesController from "./sidebar_subpages_controller"
application.register("sidebar-subpages", SidebarSubpagesController)

import DocumentFolders__CodeToggleController from "./document_folders/code_toggle_controller"
application.register("document-folders--code-toggle", DocumentFolders__CodeToggleController)

import DocumentFolders__DragController from "./document_folders/drag_controller"
application.register("document-folders--drag", DocumentFolders__DragController)

import DocumentFolders__DropZoneController from "./document_folders/drop_zone_controller"
application.register("document-folders--drop-zone", DocumentFolders__DropZoneController)

import DocumentFolders__ExternalDropController from "./document_folders/external_drop_controller"
application.register("document-folders--external-drop", DocumentFolders__ExternalDropController)

import DocumentFolders__FolderController from "./document_folders/folder_controller"
application.register("document-folders--folder", DocumentFolders__FolderController)

import DocumentFolders__SectionController from "./document_folders/section_controller"
application.register("document-folders--section", DocumentFolders__SectionController)

import DocumentFolders__SortController from "./document_folders/sort_controller"
application.register("document-folders--sort", DocumentFolders__SortController)

import DocumentFolders__UploadController from "./document_folders/upload_controller"
application.register("document-folders--upload", DocumentFolders__UploadController)

import DocumentPreviewController from "./document_preview_controller"
application.register("document-preview", DocumentPreviewController)

import DragMaterializeController from "./drag_materialize_controller"
application.register("drag-materialize", DragMaterializeController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)

import DrivingTimeDialogController from "./driving_time_dialog_controller"
application.register("driving-time-dialog", DrivingTimeDialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ViewportFitController from "./viewport_fit_controller"
application.register("viewport-fit", ViewportFitController)

import DuplicateTargetController from "./duplicate_target_controller"
application.register("duplicate-target", DuplicateTargetController)

import DurationInputController from "./duration_input_controller"
application.register("duration-input", DurationInputController)

import DynamicFormController from "./dynamic_form_controller"
application.register("dynamic-form", DynamicFormController)

import EditTaskController from "./edit_task_controller"
application.register("edit-task", EditTaskController)

import ElapsedTimeController from "./elapsed_time_controller"
application.register("elapsed-time", ElapsedTimeController)

import EmailRecipientsController from "./email_recipients_controller"
application.register("email-recipients", EmailRecipientsController)

import EmployeeBulkSelectController from "./employee_bulk_select_controller"
application.register("employee-bulk-select", EmployeeBulkSelectController)

import EmployeeDeactivateConfirmController from "./employee_deactivate_confirm_controller"
application.register("employee-deactivate-confirm", EmployeeDeactivateConfirmController)

import EmployeeDeleteModalController from "./employee_delete_modal_controller"
application.register("employee-delete-modal", EmployeeDeleteModalController)

import EmployeeDirectoryController from "./employee_directory_controller"
application.register("employee-directory", EmployeeDirectoryController)

import EmployeeHoursController from "./employee_hours_controller"
application.register("employee-hours", EmployeeHoursController)

import EmployeeOvertimeController from "./employee_overtime_controller"
application.register("employee-overtime", EmployeeOvertimeController)

import EmployeeReportChooserController from "./employee_report_chooser_controller"
application.register("employee-report-chooser", EmployeeReportChooserController)

import SectionFrameController from "./section_frame_controller"
application.register("section-frame", SectionFrameController)

import EmployeeTasksController from "./employee_tasks_controller"
application.register("employee-tasks", EmployeeTasksController)

import EmployeeWorkingHoursController from "./employee_working_hours_controller"
application.register("employee-working-hours", EmployeeWorkingHoursController)

import EmployeesController from "./employees_controller"
application.register("employees", EmployeesController)

import ExpenseApprovalModalController from "./expense_approval_modal_controller"
application.register("expense-approval-modal", ExpenseApprovalModalController)

import ExpenseDeleteModalController from "./expense_delete_modal_controller"
application.register("expense-delete-modal", ExpenseDeleteModalController)

import ExpenseReceiptExtractionController from "./expense_receipt_extraction_controller"
application.register("expense-receipt-extraction", ExpenseReceiptExtractionController)

import ExpenseQuantityController from "./expense_quantity_controller"
application.register("expense-quantity", ExpenseQuantityController)

import ExpensesSidebarController from "./expenses_sidebar_controller"
application.register("expenses-sidebar", ExpensesSidebarController)

import ExpenseItemsToggleController from "./expense_items_toggle_controller"
application.register("expense-items-toggle", ExpenseItemsToggleController)

import ExpenseItemsBulkController from "./expense_items_bulk_controller"
application.register("expense-items-bulk", ExpenseItemsBulkController)

import ExportColumnsController from "./export_columns_controller"
application.register("export-columns", ExportColumnsController)

import ExportDefaultsController from "./export_defaults_controller"
application.register("export-defaults", ExportDefaultsController)

import ExportNotificationController from "./export_notification_controller"
application.register("export-notification", ExportNotificationController)

import ExportPanelController from "./export_panel_controller"
application.register("export-panel", ExportPanelController)

import ExportStatusPollController from "./export_status_poll_controller"
application.register("export-status-poll", ExportStatusPollController)

import ExportsListController from "./exports_list_controller"
application.register("exports-list", ExportsListController)

import ExternalFetchController from "./external_fetch_controller"
application.register("external-fetch", ExternalFetchController)

import ExternalSourceAuthController from "./external_source_auth_controller"
application.register("external-source-auth", ExternalSourceAuthController)

import ExternalValueFetchController from "./external_value_fetch_controller"
application.register("external-value-fetch", ExternalValueFetchController)

import FieldEditorController from "./field_editor_controller"
application.register("field-editor", FieldEditorController)

import FieldGroupController from "./field_group_controller"
application.register("field-group", FieldGroupController)

import FieldTypeToggleController from "./field_type_toggle_controller"
application.register("field-type-toggle", FieldTypeToggleController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FileSizeLimitController from "./file_size_limit_controller"
application.register("file-size-limit", FileSizeLimitController)

import DirectUploadFormController from "./direct_upload_form_controller"
application.register("direct-upload-form", DirectUploadFormController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FillFromSourceController from "./fill_from_source_controller"
application.register("fill-from-source", FillFromSourceController)

import FilterOpenerController from "./filter_opener_controller"
application.register("filter-opener", FilterOpenerController)

import FleetCalendarController from "./fleet_calendar_controller"
application.register("fleet-calendar", FleetCalendarController)

import FleetCalendarFilterController from "./fleet_calendar_filter_controller"
application.register("fleet-calendar-filter", FleetCalendarFilterController)

import FleetCalendarSectionController from "./fleet_calendar_section_controller"
application.register("fleet-calendar-section", FleetCalendarSectionController)

import FleetMapController from "./fleet_map_controller"
application.register("fleet-map", FleetMapController)

import FleetModalController from "./fleet_modal_controller"
application.register("fleet-modal", FleetModalController)

import FleetMontageController from "./fleet_montage_controller"
application.register("fleet-montage", FleetMontageController)

import FleetNameFormatPreviewController from "./fleet_name_format_preview_controller"
application.register("fleet-name-format-preview", FleetNameFormatPreviewController)

import FleetUsageOptionsController from "./fleet_usage_options_controller"
application.register("fleet-usage-options", FleetUsageOptionsController)

import FleetsController from "./fleets_controller"
application.register("fleets", FleetsController)

import FolderAccessTreeController from "./folder_access_tree_controller"
application.register("folder-access-tree", FolderAccessTreeController)

import FormLayoutEditorController from "./form_layout_editor_controller"
application.register("form-layout-editor", FormLayoutEditorController)

import FrameDismissController from "./frame_dismiss_controller"
application.register("frame-dismiss", FrameDismissController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import GridBulkSelectController from "./grid_bulk_select_controller"
application.register("grid-bulk-select", GridBulkSelectController)

import GridCellsController from "./grid_cells_controller"
application.register("grid-cells", GridCellsController)

import GridColumnsController from "./grid_columns_controller"
application.register("grid-columns", GridColumnsController)

import GridScrollRestoreController from "./grid_scroll_restore_controller"
application.register("grid-scroll-restore", GridScrollRestoreController)

import GroupAssignController from "./group_assign_controller"
application.register("group-assign", GroupAssignController)

import GroupDashboardGridController from "./group_dashboard_grid_controller"
application.register("group-dashboard-grid", GroupDashboardGridController)

import GroupGraphController from "./group_graph_controller"
application.register("group-graph", GroupGraphController)

import TemplateGraphController from "./template_graph_controller"
application.register("template-graph", TemplateGraphController)

import ConfirmWhenUncheckedController from "./confirm_when_unchecked_controller"
application.register("confirm-when-unchecked", ConfirmWhenUncheckedController)

import GroupMemberAssignmentsController from "./group_member_assignments_controller"
application.register("group-member-assignments", GroupMemberAssignmentsController)

import GroupSitesMapController from "./group_sites_map_controller"
application.register("group-sites-map", GroupSitesMapController)

import HandbookSectionHighlightController from "./handbook_section_highlight_controller"
application.register("handbook-section-highlight", HandbookSectionHighlightController)

import HelpPopoverController from "./help_popover_controller"
application.register("help-popover", HelpPopoverController)

import HolidayBalancesController from "./holiday_balances_controller"
application.register("holiday-balances", HolidayBalancesController)

import HotkeyController from "./hotkey_controller"
application.register("hotkey", HotkeyController)

import HotkeysHelpController from "./hotkeys_help_controller"
application.register("hotkeys-help", HotkeysHelpController)

import HourlywageController from "./hourlywage_controller"
application.register("hourlywage", HourlywageController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import IcsImportController from "./ics_import_controller"
application.register("ics-import", IcsImportController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImportPollController from "./import_poll_controller"
application.register("import-poll", ImportPollController)

import InlineAddFormController from "./inline_add_form_controller"
application.register("inline-add-form", InlineAddFormController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InputValidatorController from "./input_validator_controller"
application.register("input-validator", InputValidatorController)

import LeavePayoutPrefillController from "./leave_payout_prefill_controller"
application.register("leave-payout-prefill", LeavePayoutPrefillController)

import LeaveRequestDialogController from "./leave_request_dialog_controller"
application.register("leave-request-dialog", LeaveRequestDialogController)

import LeaveRequestFilterController from "./leave_request_filter_controller"
application.register("leave-request-filter", LeaveRequestFilterController)

import LeaveRequestFormController from "./leave_request_form_controller"
application.register("leave-request-form", LeaveRequestFormController)

import LeaveRequestsSidebarController from "./leave_requests_sidebar_controller"
application.register("leave-requests-sidebar", LeaveRequestsSidebarController)

import LinkedDateController from "./linked_date_controller"
application.register("linked-date", LinkedDateController)

import ListRefreshController from "./list_refresh_controller"
application.register("list-refresh", ListRefreshController)

import ListReturnController from "./list_return_controller"
application.register("list-return", ListReturnController)

import GeofenceEditorController from "./geofence_editor_controller"
application.register("geofence-editor", GeofenceEditorController)

import GeofenceBookingController from "./geofence_booking_controller"
application.register("geofence-booking", GeofenceBookingController)

import LocationTrackMapController from "./location_track_map_controller"
application.register("location-track-map", LocationTrackMapController)

import MapsAutocompleteController from "./maps_autocomplete_controller"
application.register("maps-autocomplete", MapsAutocompleteController)

import MapsController from "./maps_controller"
application.register("maps", MapsController)

import ArticleSelectionController from "./article_selection_controller"
application.register("article-selection", ArticleSelectionController)

import MeasurementEntriesController from "./measurement_entries_controller"
application.register("measurement-entries", MeasurementEntriesController)

import MeasurementEntryController from "./measurement_entry_controller"
application.register("measurement-entry", MeasurementEntryController)

import MemberRolesDialogController from "./member_roles_dialog_controller"
application.register("member-roles-dialog", MemberRolesDialogController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import SiteActivityComposerController from "./site_activity_composer_controller"
application.register("site-activity-composer", SiteActivityComposerController)

import MileageRangesController from "./mileage_ranges_controller"
application.register("mileage-ranges", MileageRangesController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MoveReportModalController from "./move_report_modal_controller"
application.register("move-report-modal", MoveReportModalController)

import MultiEntryController from "./multi_entry_controller"
application.register("multi-entry", MultiEntryController)

import MultiSiteBookingController from "./multi_site_booking_controller"
application.register("multi-site-booking", MultiSiteBookingController)

import MyAppointmentOpenerController from "./my_appointment_opener_controller"
application.register("my-appointment-opener", MyAppointmentOpenerController)

import NameFormatPreviewController from "./name_format_preview_controller"
application.register("name-format-preview", NameFormatPreviewController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NewsItemTargetController from "./news_item_target_controller"
application.register("news-item-target", NewsItemTargetController)

import NextNumberController from "./next_number_controller"
application.register("next-number", NextNumberController)

import NotesInputTypeFormController from "./notes_input_type_form_controller"
application.register("notes-input-type-form", NotesInputTypeFormController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationReadController from "./notification_read_controller"
application.register("notification-read", NotificationReadController)

import NotificationsInboxController from "./notifications_inbox_controller"
application.register("notifications-inbox", NotificationsInboxController)

import NotificationsPopoverController from "./notifications_popover_controller"
application.register("notifications-popover", NotificationsPopoverController)

import NumberScopeChangeModalController from "./number_scope_change_modal_controller"
application.register("number-scope-change-modal", NumberScopeChangeModalController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import OnedriveConfigController from "./onedrive_config_controller"
application.register("onedrive-config", OnedriveConfigController)

import SharepointPickerController from "./sharepoint_picker_controller"
application.register("sharepoint-picker", SharepointPickerController)

import PaintModalController from "./paint_modal_controller"
application.register("paint-modal", PaintModalController)

import ParticipantCustomerPickerController from "./participant_customer_picker_controller"
application.register("participant-customer-picker", ParticipantCustomerPickerController)

import PartnerCompanyHoursController from "./partner_company_hours_controller"
application.register("partner-company-hours", PartnerCompanyHoursController)

import PartnerCompanySelectController from "./partner_company_select_controller"
application.register("partner-company-select", PartnerCompanySelectController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)
import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PaymentMethodController from "./payment_method_controller"
application.register("payment-method", PaymentMethodController)

import PayrollSubtabsController from "./payroll_subtabs_controller"
application.register("payroll-subtabs", PayrollSubtabsController)

import PdfAnnotationHistoryEntryController from "./pdf_annotation_history_entry_controller"
application.register("pdf-annotation-history-entry", PdfAnnotationHistoryEntryController)

import PdfAnnotationTaskCallbackController from "./pdf_annotation_task_callback_controller"
application.register("pdf-annotation-task-callback", PdfAnnotationTaskCallbackController)

import PdfAnnotatorController from "./pdf_annotator_controller"
application.register("pdf-annotator", PdfAnnotatorController)

import PdfFormFillingController from "./pdf_form_filling_controller"
application.register("pdf-form-filling", PdfFormFillingController)

import PdfPageBreakController from "./pdf_page_break_controller"
application.register("pdf-page-break", PdfPageBreakController)

import PdfRowEditorController from "./pdf_row_editor_controller"
application.register("pdf-row-editor", PdfRowEditorController)

import PendingAllowanceController from "./pending_allowance_controller"
application.register("pending-allowance", PendingAllowanceController)

import PermissionFilterController from "./permission_filter_controller"
application.register("permission-filter", PermissionFilterController)

import PermissionSectionController from "./permission_section_controller"
application.register("permission-section", PermissionSectionController)

import PhoneNumbersController from "./phone_numbers_controller"
application.register("phone-numbers", PhoneNumbersController)

import PhotoLocationMapController from "./photo_location_map_controller"
application.register("photo-location-map", PhotoLocationMapController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PlaceholderInsertController from "./placeholder_insert_controller"
application.register("placeholder-insert", PlaceholderInsertController)

import PlacesController from "./places_controller"
application.register("places", PlacesController)

import PlanningAllocationDialogController from "./planning_allocation_dialog_controller"
application.register("planning-allocation-dialog", PlanningAllocationDialogController)

import PlanningBlockerDialogController from "./planning_blocker_dialog_controller"
application.register("planning-blocker-dialog", PlanningBlockerDialogController)

import PlanningAllocationDragController from "./planning_allocation_drag_controller"
application.register("planning-allocation-drag", PlanningAllocationDragController)

import PlanningBoardDropController from "./planning_board_drop_controller"
application.register("planning-board-drop", PlanningBoardDropController)

import PlanningBusyController from "./planning_busy_controller"
application.register("planning-busy", PlanningBusyController)

import PlanningCardConfigTabsController from "./planning_card_config_tabs_controller"
application.register("planning-card-config-tabs", PlanningCardConfigTabsController)

import PlanningCardFieldsController from "./planning_card_fields_controller"
application.register("planning-card-fields", PlanningCardFieldsController)

import PlanningChipSortController from "./planning_chip_sort_controller"
application.register("planning-chip-sort", PlanningChipSortController)

import PlanningConfirmDialogController from "./planning_confirm_dialog_controller"
application.register("planning-confirm-dialog", PlanningConfirmDialogController)

import PlanningDemandNoteDialogController from "./planning_demand_note_dialog_controller"
application.register("planning-demand-note-dialog", PlanningDemandNoteDialogController)

import PlanningDemandGridController from "./planning_demand_grid_controller"
application.register("planning-demand-grid", PlanningDemandGridController)

import MultiEntryGridController from "./multi_entry_grid_controller"
application.register("multi-entry-grid", MultiEntryGridController)

import PlanningWeekCopyController from "./planning_week_copy_controller"
application.register("planning-week-copy", PlanningWeekCopyController)

import PlanningDispatchDialogController from "./planning_dispatch_dialog_controller"
application.register("planning-dispatch-dialog", PlanningDispatchDialogController)

import PlanningEmployeeBoardController from "./planning_employee_board_controller"
application.register("planning-employee-board", PlanningEmployeeBoardController)

import PlanningEmployeeSearchController from "./planning_employee_search_controller"
application.register("planning-employee-search", PlanningEmployeeSearchController)

import PlanningEstimateDialogController from "./planning_estimate_dialog_controller"
application.register("planning-estimate-dialog", PlanningEstimateDialogController)

import PlanningFilterController from "./planning_filter_controller"
application.register("planning-filter", PlanningFilterController)

import PlanningUtilizationController from "./planning_utilization_controller"
application.register("planning-utilization", PlanningUtilizationController)

import PlanningFlashController from "./planning_flash_controller"
application.register("planning-flash", PlanningFlashController)

import PlanningFleetAllocationDragController from "./planning_fleet_allocation_drag_controller"
application.register("planning-fleet-allocation-drag", PlanningFleetAllocationDragController)

import PlanningPanelController from "./planning_panel_controller"
application.register("planning-panel", PlanningPanelController)

import PlanningPlannableDragController from "./planning_plannable_drag_controller"
application.register("planning-plannable-drag", PlanningPlannableDragController)

import PlanningSectionController from "./planning_section_controller"
application.register("planning-section", PlanningSectionController)

import PlanningSectionToggleController from "./planning_section_toggle_controller"
application.register("planning-section-toggle", PlanningSectionToggleController)

import PlanningSidebarController from "./planning_sidebar_controller"
application.register("planning-sidebar", PlanningSidebarController)

import PlanningSiteSelectionController from "./planning_site_selection_controller"
application.register("planning-site-selection", PlanningSiteSelectionController)

import PlanningSpansDialogController from "./planning_spans_dialog_controller"
application.register("planning-spans-dialog", PlanningSpansDialogController)

import PlanningTimelineController from "./planning_timeline_controller"
application.register("planning-timeline", PlanningTimelineController)

import PlanningTooltipDelegateController from "./planning_tooltip_delegate_controller"
application.register("planning-tooltip-delegate", PlanningTooltipDelegateController)

import PlanningTradeDemandController from "./planning_trade_demand_controller"
application.register("planning-trade-demand", PlanningTradeDemandController)

import PlanningTradeFillController from "./planning_trade_fill_controller"
application.register("planning-trade-fill", PlanningTradeFillController)

import PlanningTradeFillRangeController from "./planning_trade_fill_range_controller"
application.register("planning-trade-fill-range", PlanningTradeFillRangeController)

import PlanningUndoController from "./planning_undo_controller"
application.register("planning-undo", PlanningUndoController)

import PlantafelBauleiterSectionController from "./plantafel_bauleiter_section_controller"
application.register("plantafel-bauleiter-section", PlantafelBauleiterSectionController)

import PlantafelCellController from "./plantafel_cell_controller"
application.register("plantafel-cell", PlantafelCellController)

import PlantafelConflictModalController from "./plantafel_conflict_modal_controller"
application.register("plantafel-conflict-modal", PlantafelConflictModalController)

import PlantafelConflictRefreshController from "./plantafel_conflict_refresh_controller"
application.register("plantafel-conflict-refresh", PlantafelConflictRefreshController)

import PlantafelController from "./plantafel_controller"
application.register("plantafel", PlantafelController)

import PlantafelDragController from "./plantafel_drag_controller"
application.register("plantafel-drag", PlantafelDragController)

import PlantafelDropController from "./plantafel_drop_controller"
application.register("plantafel-drop", PlantafelDropController)

import PlantafelElementController from "./plantafel_element_controller"
application.register("plantafel-element", PlantafelElementController)

import PlantafelFilterController from "./plantafel_filter_controller"
application.register("plantafel-filter", PlantafelFilterController)

import PlantafelGridController from "./plantafel_grid_controller"
application.register("plantafel-grid", PlantafelGridController)

import PlantafelMonthVisibilityController from "./plantafel_month_visibility_controller"
application.register("plantafel-month-visibility", PlantafelMonthVisibilityController)

import PlantafelNewDropdownController from "./plantafel_new_dropdown_controller"
application.register("plantafel-new-dropdown", PlantafelNewDropdownController)

import PlantafelPanelController from "./plantafel_panel_controller"
application.register("plantafel-panel", PlantafelPanelController)

import PlantafelPresenceController from "./plantafel_presence_controller"
application.register("plantafel-presence", PlantafelPresenceController)

import PlantafelResizeController from "./plantafel_resize_controller"
application.register("plantafel-resize", PlantafelResizeController)

import PlantafelSectionController from "./plantafel_section_controller"
application.register("plantafel-section", PlantafelSectionController)

import PlantafelSiteDropController from "./plantafel_site_drop_controller"
application.register("plantafel-site-drop", PlantafelSiteDropController)

import PlantafelSiteSectionController from "./plantafel_site_section_controller"
application.register("plantafel-site-section", PlantafelSiteSectionController)

import PlantafelTaskDragController from "./plantafel_task_drag_controller"
application.register("plantafel-task-drag", PlantafelTaskDragController)

import PlantafelTaskSectionController from "./plantafel_task_section_controller"
application.register("plantafel-task-section", PlantafelTaskSectionController)

import PlantafelTooltipController from "./plantafel_tooltip_controller"
application.register("plantafel-tooltip", PlantafelTooltipController)

import PlantafelTradeBarController from "./plantafel_trade_bar_controller"
application.register("plantafel-trade-bar", PlantafelTradeBarController)

import PlantafelTradeConflictModalController from "./plantafel_trade_conflict_modal_controller"
application.register("plantafel-trade-conflict-modal", PlantafelTradeConflictModalController)

import PlantafelTradeDrawerController from "./plantafel_trade_drawer_controller"
application.register("plantafel-trade-drawer", PlantafelTradeDrawerController)

import PlantafelTradeDropController from "./plantafel_trade_drop_controller"
application.register("plantafel-trade-drop", PlantafelTradeDropController)

import PlantafelTradeMismatchModalController from "./plantafel_trade_mismatch_modal_controller"
application.register("plantafel-trade-mismatch-modal", PlantafelTradeMismatchModalController)

import PlantafelTradeRequirementController from "./plantafel_trade_requirement_controller"
application.register("plantafel-trade-requirement", PlantafelTradeRequirementController)

import PlantafelTradeResizeController from "./plantafel_trade_resize_controller"
application.register("plantafel-trade-resize", PlantafelTradeResizeController)

import PlantafelTradeShortenWarningController from "./plantafel_trade_shorten_warning_controller"
application.register("plantafel-trade-shorten-warning", PlantafelTradeShortenWarningController)

import PlantafelVerticalSiteSectionController from "./plantafel_vertical_site_section_controller"
application.register("plantafel-vertical-site-section", PlantafelVerticalSiteSectionController)

import PlantafelVerticalTaskRowController from "./plantafel_vertical_task_row_controller"
application.register("plantafel-vertical-task-row", PlantafelVerticalTaskRowController)

import PoolSiteController from "./pool_site_controller"
application.register("pool-site", PoolSiteController)

import PositionPanelController from "./position_panel_controller"
application.register("position-panel", PositionPanelController)

import PositionStructureController from "./position_structure_controller"
application.register("position-structure", PositionStructureController)

import PositionTreeController from "./position_tree_controller"
application.register("position-tree", PositionTreeController)

import PositionGridShortcutsController from "./position_grid_shortcuts_controller"
application.register("position-grid-shortcuts", PositionGridShortcutsController)

import PlatformKeysController from "./platform_keys_controller"
application.register("platform-keys", PlatformKeysController)

import FillViewportController from "./fill_viewport_controller"
application.register("fill-viewport", FillViewportController)

import WorkLocationController from "./work_location_controller"
application.register("work-location", WorkLocationController)

import PrefillDateController from "./prefill_date_controller"
application.register("prefill-date", PrefillDateController)

import TimesheetDataPanelController from "./timesheet_data_panel_controller"
application.register("timesheet-data-panel", TimesheetDataPanelController)

import ProxyEntriesSectionController from "./proxy_entries_section_controller"
application.register("proxy-entries-section", ProxyEntriesSectionController)

import ProxySubmissionSettingController from "./proxy_submission_setting_controller"
application.register("proxy-submission-setting", ProxySubmissionSettingController)

import QuickApproveController from "./quick_approve_controller"
application.register("quick-approve", QuickApproveController)

import QuickCreateDialogController from "./quick_create_dialog_controller"
application.register("quick-create-dialog", QuickCreateDialogController)

import QuickEntriesController from "./quick_entries_controller"
application.register("quick-entries", QuickEntriesController)

import RecurrenceFormController from "./recurrence_form_controller"
application.register("recurrence-form", RecurrenceFormController)

import RedoTimesheetsController from "./redo_timesheets_controller"
application.register("redo-timesheets", RedoTimesheetsController)

import RegionFilterController from "./region_filter_controller"
application.register("region-filter", RegionFilterController)

import RemoteSelectController from "./remote_select_controller"
application.register("remote-select", RemoteSelectController)

import ReportBuilderController from "./report_builder_controller"
application.register("report-builder", ReportBuilderController)

import ReportCenterBulkSelectController from "./report_center_bulk_select_controller"
application.register("report-center-bulk-select", ReportCenterBulkSelectController)

import ReportAnalysisGroupsController from "./report_analysis_groups_controller"
application.register("report-analysis-groups", ReportAnalysisGroupsController)

import ReportReadingController from "./report_reading_controller"
application.register("report-reading", ReportReadingController)

import ReportSignaturesController from "./report_signatures_controller"
application.register("report-signatures", ReportSignaturesController)

import ReportTypeConfigController from "./report_type_config_controller"
application.register("report-type-config", ReportTypeConfigController)

import ReportsSubtabsController from "./reports_subtabs_controller"
application.register("reports-subtabs", ReportsSubtabsController)

import ResourceShareSectionController from "./resource_share_section_controller"
application.register("resource-share-section", ResourceShareSectionController)

import ResponsiveNavigationController from "./responsive_navigation_controller"
application.register("responsive-navigation", ResponsiveNavigationController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RichTextEditorController from "./rich_text_editor_controller"
application.register("rich-text-editor", RichTextEditorController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SalaryCalculatorController from "./salary_calculator_controller"
application.register("salary-calculator", SalaryCalculatorController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SeasonalConfigsController from "./seasonal_configs_controller"
application.register("seasonal-configs", SeasonalConfigsController)

import SeasonalDayBreaksController from "./seasonal_day_breaks_controller"
application.register("seasonal-day-breaks", SeasonalDayBreaksController)

import SeasonalDefaultTimesController from "./seasonal_default_times_controller"
application.register("seasonal-default-times", SeasonalDefaultTimesController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectRevealController from "./select_reveal_controller"
application.register("select-reveal", SelectRevealController)

import SelectWithAddableController from "./select_with_addable_controller"
application.register("select-with-addable", SelectWithAddableController)

import SeriesScopeController from "./series_scope_controller"
application.register("series-scope", SeriesScopeController)

import ScrollKeeperController from "./scroll_keeper_controller"
application.register("scroll-keeper", ScrollKeeperController)

import SettingsDirtyGuardController from "./settings_dirty_guard_controller"
application.register("settings-dirty-guard", SettingsDirtyGuardController)

import SettingsSectionNavController from "./settings_section_nav_controller"
application.register("settings-section-nav", SettingsSectionNavController)

import SettingsSearchController from "./settings_search_controller"
application.register("settings-search", SettingsSearchController)

import SettingsTabsController from "./settings_tabs_controller"
application.register("settings-tabs", SettingsTabsController)

import ShareRecipientsModalController from "./share_recipients_modal_controller"
application.register("share-recipients-modal", ShareRecipientsModalController)

import SickNoteDialogController from "./sick_note_dialog_controller"
application.register("sick-note-dialog", SickNoteDialogController)

import SickNoteDocumentExtractionController from "./sick_note_document_extraction_controller"
application.register("sick-note-document-extraction", SickNoteDocumentExtractionController)

import SickNoteFilterController from "./sick_note_filter_controller"
application.register("sick-note-filter", SickNoteFilterController)

import SickNoteFormController from "./sick_note_form_controller"
application.register("sick-note-form", SickNoteFormController)

import SickNotesSidebarController from "./sick_notes_sidebar_controller"
application.register("sick-notes-sidebar", SickNotesSidebarController)

import SicknotesBadWeatherFieldsController from "./sicknotes_bad_weather_fields_controller"
application.register("sicknotes-bad-weather-fields", SicknotesBadWeatherFieldsController)

import SideNavController from "./side_nav_controller"
application.register("side-nav", SideNavController)

import SidebarSectionController from "./sidebar_section_controller"
application.register("sidebar-section", SidebarSectionController)

import SignatureConfigController from "./signature_config_controller"
application.register("signature-config", SignatureConfigController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SiteAddressBookController from "./site_address_book_controller"
application.register("site-address-book", SiteAddressBookController)

import SiteDrivingTimeController from "./site_driving_time_controller"
application.register("site-driving-time", SiteDrivingTimeController)

import SiteLimitationFormController from "./site_limitation_form_controller"
application.register("site-limitation-form", SiteLimitationFormController)

import SiteNameFormatPreviewController from "./site_name_format_preview_controller"
application.register("site-name-format-preview", SiteNameFormatPreviewController)

import SitePasswordController from "./site_password_controller"
application.register("site-password", SitePasswordController)

import SiteReportPeriodController from "./site_report_period_controller"
application.register("site-report-period", SiteReportPeriodController)

import SiteTaskViewController from "./site_task_view_controller"
application.register("site-task-view", SiteTaskViewController)

import SiteTaskSubtasksController from "./site_task_subtasks_controller"
application.register("site-task-subtasks", SiteTaskSubtasksController)

import SiteTasksController from "./site_tasks_controller"
application.register("site-tasks", SiteTasksController)

import SitesExportController from "./sites_export_controller"
application.register("sites-export", SitesExportController)

import SitesMapController from "./sites_map_controller"
application.register("sites-map", SitesMapController)

import SitesSidebarController from "./sites_sidebar_controller"
application.register("sites-sidebar", SitesSidebarController)

import SketchController from "./sketch_controller"
application.register("sketch", SketchController)

import SlideoverController from "./slideover_controller"
application.register("slideover", SlideoverController)

import SokaFieldsController from "./soka_fields_controller"
application.register("soka-fields", SokaFieldsController)

import SortableController from "./sortable_controller"
import StatusLanesController from "./status_lanes_controller"
import StatusPickerController from "./status_picker_controller"
application.register("sortable", SortableController)
application.register("status-lanes", StatusLanesController)
application.register("status-picker", StatusPickerController)

import StreamLoaderController from "./stream_loader_controller"
application.register("stream-loader", StreamLoaderController)

import MatrixFillController from "./matrix_fill_controller"
application.register("matrix-fill", MatrixFillController)

import SubmitButtonController from "./submit_button_controller"
application.register("submit-button", SubmitButtonController)

import SubtaskBulkSelectController from "./subtask_bulk_select_controller"
application.register("subtask-bulk-select", SubtaskBulkSelectController)

import SubtaskExpandController from "./subtask_expand_controller"
application.register("subtask-expand", SubtaskExpandController)

import SubtaskFormController from "./subtask_form_controller"
application.register("subtask-form", SubtaskFormController)

import SubtaskMentionController from "./subtask_mention_controller"
application.register("subtask-mention", SubtaskMentionController)

import SupportAttachmentsController from "./support_attachments_controller"
application.register("support-attachments", SupportAttachmentsController)

import SurchargeToggleController from "./surcharge_toggle_controller"
application.register("surcharge-toggle", SurchargeToggleController)

import SystemAnnouncementController from "./system_announcement_controller"
application.register("system-announcement", SystemAnnouncementController)

import TariffAverageWageController from "./tariff_average_wage_controller"
application.register("tariff-average-wage", TariffAverageWageController)

import TariffReviewGridController from "./tariff_review_grid_controller"
application.register("tariff-review-grid", TariffReviewGridController)

import TariffWageSuggestionController from "./tariff_wage_suggestion_controller"
application.register("tariff-wage-suggestion", TariffWageSuggestionController)

import TableBulkSelectController from "./table_bulk_select_controller"
application.register("table-bulk-select", TableBulkSelectController)

import TaskBulkSelectController from "./task_bulk_select_controller"
application.register("task-bulk-select", TaskBulkSelectController)

import TaskClosingReportController from "./task_closing_report_controller"
application.register("task-closing-report", TaskClosingReportController)

import TaskDeleteModalController from "./task_delete_modal_controller"
application.register("task-delete-modal", TaskDeleteModalController)

import TaskPdfEmailModalController from "./task_pdf_email_modal_controller"
application.register("task-pdf-email-modal", TaskPdfEmailModalController)

import TaskSelectController from "./task_select_controller"
application.register("task-select", TaskSelectController)

import TaskTypeSelectController from "./task_type_select_controller"
application.register("task-type-select", TaskTypeSelectController)

import Tasks__CopyConstructionController from "./tasks/copy_construction_controller"
application.register("tasks--copy-construction", Tasks__CopyConstructionController)

import Tasks__DuplicateFoldersController from "./tasks/duplicate_folders_controller"
application.register("tasks--duplicate-folders", Tasks__DuplicateFoldersController)

import Tasks__FormController from "./tasks/form_controller"
application.register("tasks--form", Tasks__FormController)

import Tasks__SitedatesController from "./tasks/sitedates_controller"
application.register("tasks--sitedates", Tasks__SitedatesController)

import Tasks__ToggleSignContainerController from "./tasks/toggle_sign_container_controller"
application.register("tasks--toggle-sign-container", Tasks__ToggleSignContainerController)

import TasksMapController from "./tasks_map_controller"
application.register("tasks-map", TasksMapController)

import TasksSidebarController from "./tasks_sidebar_controller"
application.register("tasks-sidebar", TasksSidebarController)

import TeamDeleteModalController from "./team_delete_modal_controller"
application.register("team-delete-modal", TeamDeleteModalController)

import TeamRemoveMemberModalController from "./team_remove_member_modal_controller"
application.register("team-remove-member-modal", TeamRemoveMemberModalController)

import TemplateSettingsCardController from "./template_settings_card_controller"
application.register("template-settings-card", TemplateSettingsCardController)

import TemplateListController from "./template_list_controller"
application.register("template-list", TemplateListController)

import TextBlockDefaultsController from "./text_block_defaults_controller"
application.register("text-block-defaults", TextBlockDefaultsController)

import TextSegmentsController from "./text_segments_controller"
application.register("text-segments", TextSegmentsController)

import TimeAccountController from "./time_account_controller"
application.register("time-account", TimeAccountController)

import TimePickerController from "./time_picker_controller"
application.register("time-picker", TimePickerController)

import TimeSheetsPrefilledController from "./time_sheets_prefilled_controller"
application.register("time-sheets-prefilled", TimeSheetsPrefilledController)

import TimeSnapController from "./time_snap_controller"
application.register("time-snap", TimeSnapController)

import TimeStepperController from "./time_stepper_controller"
application.register("time-stepper", TimeStepperController)

import TimesheetLinkController from "./timesheet_link_controller"
application.register("timesheet-link", TimesheetLinkController)

import TimelineEntryController from "./timeline_entry_controller"
application.register("timeline-entry", TimelineEntryController)

import TimelineNewEntryController from "./timeline_new_entry_controller"
application.register("timeline-new-entry", TimelineNewEntryController)

import TimelinePdfExportController from "./timeline_pdf_export_controller"
application.register("timeline-pdf-export", TimelinePdfExportController)

import TimelineQuickEditController from "./timeline_quick_edit_controller"
application.register("timeline-quick-edit", TimelineQuickEditController)

import TimelineSelectController from "./timeline_select_controller"
application.register("timeline-select", TimelineSelectController)

import TimesheetBulkSelectController from "./timesheet_bulk_select_controller"
application.register("timesheet-bulk-select", TimesheetBulkSelectController)

import TimesheetDialogController from "./timesheet_dialog_controller"
application.register("timesheet-dialog", TimesheetDialogController)

import TimesheetNewEntryController from "./timesheet_new_entry_controller"
application.register("timesheet-new-entry", TimesheetNewEntryController)

import TimesheetRowController from "./timesheet_row_controller"
application.register("timesheet-row", TimesheetRowController)

import TimesheetSearchController from "./timesheet_search_controller"
application.register("timesheet-search", TimesheetSearchController)

import TimesheetTemplateBuilderController from "./timesheet_template_builder_controller"
application.register("timesheet-template-builder", TimesheetTemplateBuilderController)

import TimesheetUploadFieldController from "./timesheet_upload_field_controller"
application.register("timesheet-upload-field", TimesheetUploadFieldController)

import TimesheetTemplateDeleteModalController from "./timesheet_template_delete_modal_controller"
application.register("timesheet-template-delete-modal", TimesheetTemplateDeleteModalController)

import TimesheetTemplateSignaturesController from "./timesheet_template_signatures_controller"
application.register("timesheet-template-signatures", TimesheetTemplateSignaturesController)

import TimesheetVoiceController from "./timesheet_voice_controller"
application.register("timesheet-voice", TimesheetVoiceController)

import CustomReportVoiceController from "./custom_report_voice_controller"
application.register("custom-report-voice", CustomReportVoiceController)

import ToggleBreakTimeController from "./toggle_break_time_controller"
application.register("toggle-break-time", ToggleBreakTimeController)

import ToggleSubmitController from "./toggle_submit_controller"
application.register("toggle-submit", ToggleSubmitController)

import TrainingScheduleGridController from "./training_schedule_grid_controller"
application.register("training-schedule-grid", TrainingScheduleGridController)

import TranslationController from "./translation_controller"
application.register("translation", TranslationController)

import UnifiedDialogController from "./unified_dialog_controller"
application.register("unified-dialog", UnifiedDialogController)

import UnifiedFilterController from "./unified_filter_controller"
application.register("unified-filter", UnifiedFilterController)

import UnifiedToolbarController from "./unified_toolbar_controller"
application.register("unified-toolbar", UnifiedToolbarController)

import UniqueOptionsController from "./unique_options_controller"
application.register("unique-options", UniqueOptionsController)

import UploadsController from "./uploads_controller"
application.register("uploads", UploadsController)

import VehicleSelectionController from "./vehicle_selection_controller"
application.register("vehicle-selection", VehicleSelectionController)

import WarningsEditorController from "./warnings_editor_controller"
application.register("warnings-editor", WarningsEditorController)

import WeekdayFilterController from "./weekday_filter_controller"
application.register("weekday-filter", WeekdayFilterController)

import WorkTimeLimitController from "./work_time_limit_controller"
application.register("work-time-limit", WorkTimeLimitController)

import WorkTimeModelEditorController from "./work_time_model_editor_controller"
application.register("work-time-model-editor", WorkTimeModelEditorController)

import WorkTimePeriodModeController from "./work_time_period_mode_controller"
application.register("work-time-period-mode", WorkTimePeriodModeController)

import WorkTimeRulesController from "./work_time_rules_controller"
application.register("work-time-rules", WorkTimeRulesController)

import WorkTimeRulesDialogController from "./work_time_rules_dialog_controller"
application.register("work-time-rules-dialog", WorkTimeRulesDialogController)

import WorkingHoursSumController from "./working_hours_sum_controller"
application.register("working-hours-sum", WorkingHoursSumController)

import GlossaryTermController from "./glossary_term_controller"
application.register("glossary-term", GlossaryTermController)

import LoadAfterFrameController from "./load_after_frame_controller"
application.register("load-after-frame", LoadAfterFrameController)

import InspectionItemController from "./inspection_item_controller"
application.register("inspection-item", InspectionItemController)
